import { logError } from '@/utils/SentryLogger';

// Cliente de @grupopuntacana/nova-sdk. Se crea en la primera llamada y no al importar
// el módulo: así el SDK (y openai) va en un chunk aparte, y un token inválido
// (NovaConfigError) no tumba el store que instancia este servicio.
let clientPromise = null;

const getClient = () => {
  if (!clientPromise) {
    clientPromise = import('@grupopuntacana/nova-sdk')
      .then(({ Nova }) => new Nova({
        apiKey: import.meta.env.VITE_NOVA_TOKEN, // token de frontend (nova_pk_…)
        baseURL: import.meta.env.VITE_NOVA_BASE_URL, // …/api/v1
        timeout: 60000,
      }))
      .catch((e) => {
        clientPromise = null;
        throw e;
      });
  }
  return clientPromise;
};

class NovaService {
  // Extrae los datos de una cédula o pasaporte con el agente identification_wrapper.
  // `content` es la imagen del documento en base64 (sin prefijo data:).
  // eslint-disable-next-line class-methods-use-this
  async extractIdentificationData(content) {
    const image = `${content}`.split(',').pop();

    try {
      const client = await getClient();
      return await client.agents.run({
        model: 'nova-ocr',
        agent: 'identification-wrapper',
        messages: [
          {
            role: 'user',
            content: [
              {
                type: 'image_url',
                image_url: { url: image },
              },
            ],
          },
        ],
      });
    } catch (e) {
      console.error('[NovaService] Error extrayendo datos del documento', e);
      // requestId permite ubicar la traza de la llamada en Langfuse
      logError(e, 'nova-extract-identification', {
        requestId: e?.requestID ?? null,
        status: e?.status ?? null,
      });
      return null;
    }
  }
}

export default NovaService;
